import {
  Paper,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Chip,
  Stack,
  Box,
  useMediaQuery
} from '@mui/material';
import axiosInstance from '../../store/api';

export default function PendingPaymentsTable({ payments, onResolved }) {
  const isMobile = useMediaQuery('(max-width:768px)');

  const approve = async (paymentId) => {
    if (!window.confirm('¿Confirmar aprobación del pago?')) return;
    await axiosInstance.post(`/subscriptions/${paymentId}/approve`);
    onResolved();
  };

  const reject = async (paymentId) => {
    const note = prompt('Motivo del rechazo (opcional):');
    await axiosInstance.post(`/subscriptions/${paymentId}/reject`, { note });
    onResolved();
  };

  if (!payments || payments.length === 0) return null;

  return (
    <Paper sx={{ p: 3, mb: 4, bgcolor: '#fffbe6' }}>
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        Pagos Pendientes 🔔
      </Typography>

      {/* ================= MOBILE ================= */}
      {isMobile && (
        <Stack spacing={2}>
          {payments.map(p => (
            <Paper key={p._id} sx={{ p: 2, borderRadius: 2 }}>
              <Stack spacing={1}>
                <Typography fontWeight="bold">
                  {p.user.nombre} {p.user.apellido}
                </Typography>

                <Typography variant="body2" color="text.secondary">
                  Usuario: {p.user.username || p.user.email}
                </Typography>

                <Typography variant="body2">
                  App: <strong>{`${p.appKey}${p.additionalSellerSeats ? ` · ${p.additionalSellerSeats} vendedores extra` : ''} · ${p.currency || 'BOB'} ${p.amount ?? '—'} / ${p.billingPeriod === 'year' ? 'año' : 'mes'}`}</strong>
                </Typography>

                <Typography variant="body2">
                  Código: <strong>{p.user.personal_code}</strong>
                </Typography>

                <Typography variant="caption" color="text.secondary">
                  {new Date(p.createdAt).toLocaleString()}
                </Typography>

                <Chip
                  label="Pendiente"
                  color="warning"
                  size="small"
                  sx={{ alignSelf: 'flex-start' }}
                />

                <Stack direction="row" spacing={1} mt={1}>
                  <Button
                    fullWidth
                    size="small"
                    variant="contained"
                    color="success"
                    onClick={() => approve(p._id)}
                  >
                    Aprobar
                  </Button>
                  <Button
                    fullWidth
                    size="small"
                    variant="outlined"
                    color="error"
                    onClick={() => reject(p._id)}
                  >
                    Rechazar
                  </Button>
                </Stack>
              </Stack>
            </Paper>
          ))}
        </Stack>
      )}

      {/* ================= DESKTOP ================= */}
      {!isMobile && (
        <Box sx={{ overflowX: 'auto' }}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Usuario</TableCell>
                <TableCell>App</TableCell>
                <TableCell>Código</TableCell>
                <TableCell>Fecha</TableCell>
                <TableCell align="center">Estado</TableCell>
                <TableCell align="center">Acciones</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {payments.map(p => (
                <TableRow key={p._id}>
                  <TableCell>
                    <strong>
                      {p.user.nombre} {p.user.apellido}
                    </strong>
                    <br />
                    <small>{p.user.username || p.user.email}</small>
                  </TableCell>

                  <TableCell>{`${p.appKey}${p.additionalSellerSeats ? ` · ${p.additionalSellerSeats} vendedores extra` : ''} · ${p.currency || 'BOB'} ${p.amount ?? '—'} / ${p.billingPeriod === 'year' ? 'año' : 'mes'}`}</TableCell>

                  <TableCell>
                    <strong>{p.user.personal_code}</strong>
                  </TableCell>

                  <TableCell>
                    {new Date(p.createdAt).toLocaleString()}
                  </TableCell>

                  <TableCell align="center">
                    <Chip label="Pendiente" color="warning" size="small" />
                  </TableCell>

                  <TableCell align="center">
                    <Stack direction="row" spacing={1} justifyContent="center">
                      <Button
                        size="small"
                        variant="contained"
                        color="success"
                        onClick={() => approve(p._id)}
                      >
                        Aprobar
                      </Button>
                      <Button
                        size="small"
                        variant="outlined"
                        color="error"
                        onClick={() => reject(p._id)}
                      >
                        Rechazar
                      </Button>
                    </Stack>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      )}
    </Paper>
  );
}
